import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import { Avatar, Chip, TextField } from 'material-ui';
import i18n from 'i18next';
import styles from '../../../styles/styles';
import {
    renderFavoriteCheckbox, renderNumberField,
    renderSuperSelectField,
    renderTextField,
    renderVisibleCheckBox,
} from '../../../services/form';
import style from '../../../styles/styles';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ControlledEditor from '../../form/ControlledEditor/ControlledEditor';
import withTranslation from '../../../hoc/withTranslation';
import { RICHTEXT } from '../../../constants/customfiled';

const validate = values => {
    const errors = {};
    [
        'name',
        'description',
        'latitude',
        'longitude',
    ].forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });
    [
        'latitude',
        'longitude',
    ].forEach(field => {
        const value = values[field];
        if ((
            isNaN(Number.parseFloat(value))
        ) && errors[field] === undefined) {
            errors[field] = i18n.t('generic.value_must_be_int');
        }
    });
    if (
        values['tag'] !== undefined
        && values['tag'] !== null
        && values['tag'] !== ''
        && values['tag'].length > 100
    ) {
        errors['tag'] = i18n.t('generic.tag_length_gt_100');
    }

    return errors;
};

export class PointForm extends React.Component {

    static propTypes = {
        customFields: PropTypes.arrayOf(PropTypes.object),
        types: PropTypes.arrayOf(PropTypes.object),
        latlng: PropTypes.object,
        address: PropTypes.string,
        point: PropTypes.object,
        onAddressChanged: PropTypes.func,
        onLatChanged: PropTypes.func,
        onLngChanged: PropTypes.func,
        onFindAddress: PropTypes.func,
        onFormReset: PropTypes.func,
    };

    static defaultProps = {
        types: [],
        customFields: [],
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.latlng && this.props.latlng !== nextProps.latlng) {
            const newLat = (
                typeof nextProps.latlng.lat === 'string'
            )
                ? Number.parseFloat(nextProps.latlng.lat)
                : nextProps.latlng.lat;
            const newLng = (
                typeof nextProps.latlng.lng === 'string'
            )
                ? Number.parseFloat(nextProps.latlng.lng)
                : nextProps.latlng.lng;
            this.props.change('latitude', newLat);
            this.props.change('longitude', newLng);
        }
    }

    // Handlers

    onResetForm = () => {
        this.props.reset();

        if (this.props.onFormReset) {
            this.props.onFormReset();
        }
    };

    onLatChanged = (event) => {
        const value = event.target.value;
        if (this.props.onLatChanged && value && !isNaN(Number.parseFloat(value))) {
            this.props.onLatChanged(Number.parseFloat(value));
        }
    };

    onLngChanged = (event) => {
        const value = event.target.value;
        const newLng = Number.parseFloat(value);
        if (this.props.onLngChanged && value && !isNaN(newLng)) {
            this.props.onLngChanged(newLng);
        }
    };

    onAddressChanged = event => {
        const value = event.target.value;

        if (this.props.onAddressChanged) {
            this.props.onAddressChanged(value);
        }
    };

    onFindAddress = () => {
        const value = this.props.address;
        if (this.props.onFindAddress && value) {
            this.props.onFindAddress(value);
        }
    };

    // Render

    renderTypesSelection = (types, hintText) => {
        if (!types || types.length === 0) {
            return hintText;
        }

        return (
            <div style={style.chip.wrapper}>
                {types.map(({
                    value,
                    label,
                }, index) => {

                    let type = this.props.types.find((type) => {
                        return type.id === value;
                    });

                    if (type) {
                        return (
                            <Chip
                                key={value}
                                style={style.chip.margin}
                            >
                                <Avatar
                                    icon={type.picture &&
                                        <img
                                            src={type.picture}
                                            alt=""
                                            style={style.image.contain}
                                        />}
                                    size={20}
                                    backgroundColor={type.color}
                                    style={{ overflow: 'hidden' }}
                                />
                                {type.name}
                            </Chip>
                        );
                    } else {
                        return hintText;
                    }
                })}
            </div>
        );
    };

    render() {
        const {
            handleSubmit,
            pristine,
            submitting,
        } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div>
                    <Field
                        id="is_favorite"
                        name="is_favorite"
                        component={renderFavoriteCheckbox}
                        label="Favoris"
                    />
                    <Field
                        style={{ marginTop: '10px' }}
                        id="visible"
                        name="visible"
                        component={renderVisibleCheckBox}
                        label="Visible"
                    />
                    <Field
                        id="latitude"
                        name="latitude"
                        component={renderNumberField}
                        label="Latitude"
                        onChange={this.onLatChanged}
                        fullWidth={true}
                        type="number"
                    />
                    <Field
                        id="longitude"
                        name="longitude"
                        component={renderNumberField}
                        label="Longitude"
                        onChange={this.onLngChanged}
                        fullWidth={true}
                        type="number"
                    />
                    <TextField
                        id="address"
                        hintText="Address"
                        floatingLabelText="Address"
                        onChange={this.onAddressChanged}
                        fullWidth={true}
                        value={this.props.address || ''}
                    />
                    <RaisedButton
                        label="Find Address on map"
                        disabled={submitting}
                        type="button"
                        onClick={this.onFindAddress}
                        primary={true}
                    />
                    <Field
                        id="name"
                        name="name"
                        component={renderTextField}
                        label={this.props.t('generic.name')}
                        fullWidth={true}
                    />
                    <Field
                        id="description"
                        name="description"
                        component={ControlledEditor}
                        initialValue={this.props.initialValues
                            ? this.props.initialValues.description
                            : ''}
                        label="Description"
                        fullWidth={true}
                    />
                    <Field
                        id="tag"
                        name="tag"
                        component={renderTextField}
                        label="Tag"
                        fullWidth={true}
                    />
                    <Field
                        id="types_id"
                        name="types_id"
                        label="Types"
                        style={{ marginTop: 30 }}
                        component={renderSuperSelectField}
                        fullWidth={true}
                        selectionsRenderer={this.renderTypesSelection}
                        normalize={values => {
                            if (!values) {
                                return [];
                            }

                            return values.map(({
                                value,
                                label,
                            }) => {
                                return value;
                            });
                        }}
                        format={values => {
                            if (!values) {
                                return [];
                            }

                            return values.map(typeId => {
                                const type = this.props.types.find(type => type.id === typeId);
                                return {
                                    value: typeId,
                                    label: type ? type.name : typeId,
                                };
                            });
                        }}
                    >
                        {this.props.types.map((type) => (
                            <div
                                key={type.id}
                                value={type.id}
                                label={type.name}
                            >
                                <Avatar
                                    style={style.margin.right.small}
                                    icon={type.picture &&
                                        <img
                                            src={type.picture}
                                            alt=""
                                            style={style.image.contain}
                                        />}
                                    size={20}
                                    backgroundColor={type.color}
                                />
                                {type.name}
                            </div>
                        ))}
                    </Field>
                    {this.props.customFields && this.props.customFields.map((cf) => {
                        let name = cf.name;

                        if (cf.tag && cf.tag.length > 0) {
                            name += ' (' + cf.tag + ')';
                        }
                        if (cf.type === RICHTEXT) {
                            return (
                                <Field
                                    key={cf.id}
                                    id={cf.id}
                                    name={cf.id}
                                    component={ControlledEditor}
                                    initialValue={this.props.initialValues
                                        ? this.props.initialValues[cf.id]
                                        : ''}
                                    label={name}
                                    fullWidth={true}
                                />
                            );
                        } else {
                            return (
                                <Field
                                    key={cf.id}
                                    id={cf.id}
                                    name={cf.id}
                                    component={renderTextField}
                                    label={name}
                                    fullWidth={true}
                                />
                            );
                        }
                    })}
                </div>
                <div style={styles.formButtons}>
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t('generic.save')}
                        disabled={pristine || submitting}
                        type="submit"
                        primary={true}
                    />
                    {this.props.point == null &&
                        <RaisedButton
                            style={styles.formButton}
                            label={this.props.t('generic.save_and_create_new')}
                            disabled={pristine || submitting}
                            type="button"
                            primary={true}
                            onClick={() => {
                                // In case of success, handle submit returns undefined, otherwise it returns the list of errors
                                if (handleSubmit() === undefined) {
                                    this.onResetForm();
                                }
                            }}
                        />
                    }
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t('generic.reset')}
                        type="button"
                        disabled={pristine || submitting}
                        onClick={this.onResetForm}
                    />
                </div>
            </form>
        );
    }
}

export default reduxForm({
    form: 'editPoint',
    validate,
})(withTranslation(PointForm));



// WEBPACK FOOTER //
// src/components/openexplore/PointForm/PointForm.js